import React from 'react';
import DocumentTitle from 'react-document-title';
import {
  defineMessages,
  FormattedMessage,
  FormattedHTMLMessage,
} from 'react-intl';
import { Element } from 'react-scroll';
import withStyles from 'isomorphic-style-loader/lib/withStyles';

import s from './Home.scss';
import messages from './messages';
import timeMessages from '../time/messages';
import licenseMessages from '../license/messages';
import Layout from '../../components/Layout';
import Products from './products/Products';
import Customers from './customers/Customers';
import atoms from './products/atoms.svg';
import creativity from './products/creativity.svg';
import danube from './products/fishy_blue.svg';
import training from './products/training.svg';
import recruiting from './products/recruiting.svg';
import custom from './products/custom.svg';

const serviceMessages = defineMessages({
  waltzingTraining: {
    id: 'services.waltzingTraining',
    defaultMessage: 'Get Smart in Training',
    description: 'Heading for Waltzing Training in services',
  },
  waltzingTrainingDescription: {
    id: 'services.waltzingTrainingDescription',
    defaultMessage: `
      Training doesn't need to be hard - learn new
      skills through a playful experience
    `,
    description: 'Description for Waltzing Training in services',
  },
  waltzingRecruiting: {
    id: 'services.waltzingRecruiting',
    defaultMessage: 'Get Smart in Recruiting',
    description: 'Heading for Waltzing Recruiting in services',
  },
  waltzingRecruitingDescription: {
    id: 'services.waltzingRecruitingDescription',
    defaultMessage: `
      Find not only better but fitting candidates for your
      open positions by the means of playing
    `,
    description: 'Description for Waltzing Recruiting in services',
  },
  waltzingCustom: {
    id: 'services.waltzingCustom',
    defaultMessage: 'Get Smart in Everything',
    description: 'Heading for Waltzing Custom in services',
  },
  waltzingCustomDescription: {
    id: 'services.waltzingCustomDescription',
    defaultMessage: `
      We gamify everything - get in touch with us
      and we will provide you with a tailor-made,
      playful solution
    `,
    description: 'Description for Waltzing Custom in services',
  },
  linkLabel: {
    id: 'services.linkLabel',
    defaultMessage: 'Contact Us',
    description: 'Label for service link in services',
  },
});

/* eslint-disable prettier/prettier */
const services = [
  {
    name: 'Training',
    logo: training,
    color: 'grey',
    heading: <FormattedMessage {...serviceMessages.waltzingTraining} />,
    description: <FormattedMessage {...serviceMessages.waltzingTrainingDescription} />,
    link: 'mailto:sales@waltzing.at',
    linkLabel: <FormattedMessage {...serviceMessages.linkLabel} />,
  },
  {
    name: 'Recruiting',
    logo: recruiting,
    color: 'grey',
    heading: <FormattedMessage {...serviceMessages.waltzingRecruiting} />,
    description: <FormattedMessage {...serviceMessages.waltzingRecruitingDescription} />,
    link: 'mailto:sales@waltzing.at',
    linkLabel: <FormattedMessage {...serviceMessages.linkLabel} />,
  },
  {
    name: 'Custom',
    logo: custom,
    color: 'grey',
    heading: <FormattedMessage {...serviceMessages.waltzingCustom} />,
    description: <FormattedMessage {...serviceMessages.waltzingCustomDescription} />,
    link: 'mailto:sales@waltzing.at',
    linkLabel: <FormattedMessage {...serviceMessages.linkLabel} />,
  },
];
/* eslint-enable prettier/prettier */

const productMessages = defineMessages({
  waltzingAtoms: {
    id: 'products.waltzingAtoms',
    defaultMessage: 'Smart Chemistry',
    description: 'Heading for Waltzing Atoms in products',
  },
  waltzingAtomsDescription: {
    id: 'products.waltzingAtomsDescription',
    defaultMessage: `
      Playfully learn chemistry with breath-taking chemical reactions and
      structures in 3D
    `,
    description: 'Description for Waltzing Atoms in products',
  },
  waltzingCreativity: {
    id: 'products.waltzingCreativity',
    defaultMessage: 'Smart Creativity',
    description: 'Heading for Waltzing Creativity in products',
  },
  waltzingCreativityDescription: {
    id: 'products.waltzingCreativityDescription',
    defaultMessage: `
      Playfully experience and develop your creative skills
      through relaxing and intuitive gameplay
    `,
    description: 'Description for Waltzing Creativity in products',
  },
  danube: {
    id: 'products.danube',
    defaultMessage: 'Smart AI',
    description: 'Heading for danube in products',
  },
  danubeDescription: {
    id: 'products.danubeDescription',
    defaultMessage: `
      Stop fishing for data in the dark.
      With danube, you’ll catch the right fish.
    `,
    description: 'Description for danube in products',
  },
  time: {
    id: 'products.time',
    defaultMessage: 'Smart Time Tracking',
    description: 'Heading for Time in products',
  },
  license: {
    id: 'products.license',
    defaultMessage: 'Smart License Management',
    description: 'Heading for License in products',
  },
  linkLabel: {
    id: 'products.linkLabel',
    defaultMessage: 'GO GET IT',
    description: 'Label for product links in products',
  },
  comingSoon: {
    id: 'products.comingSoon',
    defaultMessage: 'COMING SOON',
    description: 'Label for coming soon in products',
  },
  learnMore: {
    id: 'products.learnMore',
    defaultMessage: 'LEARN MORE',
    description: 'Label for product links in products',
  },
});

/* eslint-disable prettier/prettier */
const products = [
  {
    name: 'Time',
    waltzingTitle: true,
    logo: "/product/time.svg",
    color: 'green',
    heading: <FormattedMessage {...productMessages.time} />,
    description: <FormattedMessage {...timeMessages.description} />,
    link: '/time',
    linkLabel: <FormattedMessage {...productMessages.learnMore} />,
    openNewPage: false,
  },
  {
    name: 'License',
    waltzingTitle: true,
    logo: "/product/license.svg",
    color: 'purple',
    heading: <FormattedMessage {...productMessages.license} />,
    description: <FormattedMessage {...licenseMessages.description} />,
    link: '/license',
    linkLabel: <FormattedMessage {...productMessages.learnMore} />,
    openNewPage: false,
  },
  {
    name: 'danube.ai',
    logo: danube,
    color: 'blue',
    heading: <FormattedMessage {...productMessages.danube} />,
    description: <FormattedMessage {...productMessages.danubeDescription} />,
    link: 'https://www.danube.ai',
    linkLabel: <FormattedMessage {...productMessages.learnMore} />,
    openNewPage: true,
  },
  {
    name: 'Atoms',
    waltzingTitle: true,
    logo: atoms,
    color: 'green',
    heading: <FormattedMessage {...productMessages.waltzingAtoms} />,
    description: <FormattedMessage {...productMessages.waltzingAtomsDescription} />,
    link: 'http://www.waltzingatoms.com',
    linkLabel: <FormattedMessage {...productMessages.learnMore} />,
    openNewPage: true,
  },
  {
    name: 'Creativity',
    waltzingTitle: true,
    logo: creativity,
    color: 'purple',
    heading: <FormattedMessage {...productMessages.waltzingCreativity} />,
    description: <FormattedMessage {...productMessages.waltzingCreativityDescription} />,
    link: 'http://creativity.waltzing.at',
    linkLabel: <FormattedMessage {...productMessages.learnMore} />,
    openNewPage: true,
  },
];
/* eslint-enable prettier/prettier */

class Home extends React.Component {
  render() {
    return (
      <DocumentTitle title="Waltzing">
        <Layout>
          <div className={s.container}>
            <Element name="home">
              <div className={s.section}>
                <h1>
                  <FormattedHTMLMessage {...messages.heading} />
                </h1>
                <img
                  src="/header.jpg"
                  alt="Waltzing"
                  className={`img-responsive ${s.contentImage}`}
                />
              </div>
            </Element>
            <div className={s.section}>
              <Element name="getSmart">
                <Products products={products} />
              </Element>
              <Element name="services">
                <Products
                  products={services}
                  heading={<FormattedMessage {...messages.ourServices} />}
                  className={s.services}
                />
              </Element>
              <Customers />
            </div>
          </div>
        </Layout>
      </DocumentTitle>
    );
  }
}

export default withStyles(s)(Home);



// WEBPACK FOOTER //
// ./src/routes/home/Home.js